import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { PostnummerFullRow } from "../_SharedTypes/PostnummerFullRow";

export interface GetCityForZipCodeResponse extends BackendResponse {
  item: PostnummerFullRow;
}

export interface GetCityForZipCodeParams extends NextApiParams {
  zipCode: string;
}

export const getCityForZipCode = withNextApi<
  GetCityForZipCodeResponse,
  GetCityForZipCodeParams
>("/cvp/CvpGetCityForZipCode");
